import BookingReservationForm from "./component/BookingReservationForm";
import Rangepicker from "./component/Rangepicker";
import FormNumber from "./component/FormNumber";
import BookingHeaderForm from "./component/BookingHeaderForm";
import BookingRoomType from "./component/BookingRoomType";
import ScrollAnchor from "./component/ScrollAnchor";
import BookingRoomModal from "./component/BookingRoomModal";
import DedicationForm from "./component/DedicationForm";
import InfoText from "./component/InfoText";
import VoucherCount from "./component/VoucherCount";
import TinySliders from "./component/TinySlider";
import MobileNavbar from "./component/MobileNavbar";
import HeaderNavbar from "./component/HeaderNavbar";
import BookingHeaderPlus from "./component/BookingHeaderPlus";


document.addEventListener('DOMContentLoaded', _naja.initialize.bind(_naja));

window.addEventListener('DOMContentLoaded', () => {
    BookingReservationForm.init();
    Rangepicker.init();
    FormNumber.init();
    BookingHeaderForm.init();
    BookingRoomType.init();
    ScrollAnchor.init();
    BookingRoomModal.init();
    DedicationForm.init();
    InfoText.init();
    VoucherCount.init();
    TinySliders.init();
    MobileNavbar.init();
    HeaderNavbar.init();
    BookingHeaderPlus.init();
});

window.addEventListener('scroll', () => {
});
